import Layout from '@/components/layout/Layout';
import { FC } from 'react';
import { useRef } from 'react';
import BookInfoDownload from '@/components/ui/book-info-download/BookInfoDownload';
import LitresWidget from '@/components/ui/litres-widget/LitresWidget';
import { getAuthorFullName } from '@/helpers/helpers';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';
import { BOOK_WIDGET_DOWNLOAD_LFROM } from '@/helpers/variables';
import { IBookShortDetail } from '@/interfaces/bookShortDetail.interface';

interface IBookDetailDownloadPage {
  book: IBookShortDetail;
}

const BookDetailDownload: FC<IBookDetailDownloadPage> = ({ book }) => {
  const bookData = book.book;
  const { first_name, middle_name, last_name } = book.author;

  const refReviewForm = useRef<HTMLDivElement>(null);

  const authorFullName = getAuthorFullName(first_name, middle_name, last_name);
  const SEO_TITLE = `${book.book.title} - скачать бесплатно fb2, epub, pdf без регистрации, автор ${authorFullName}`;
  const SEO_DESCRIPTION = `${book.book.title} ⏩ скачать бесплатно fb2, epub, pdf и без регистрации, ✨ ${authorFullName}. 📚 Электронная библиотека КучаКниг.`;
  const SEO_CANONICAL = useGetUrlPath();
  const SEO_COVER = `https://kuchaknig.org/covers/${bookData.external_id}.jpg`;

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref={SEO_CANONICAL} cover={SEO_COVER} robotsNoFollow={true}>
      <BookInfoDownload book={book} formRef={refReviewForm} />

      {book.hide_litres_data !== true && <LitresWidget bookTitle={bookData.title} authorName={authorFullName} lfrom={Number(BOOK_WIDGET_DOWNLOAD_LFROM)} />}
    </Layout>
  );
};

export default BookDetailDownload;
